import { Form } from 'antd';
import { FormProps } from 'antd/lib';
import { useEffect, useMemo } from 'react';

import useFormInitialSet from '@/hooks/useFormInitialSet';
import { useSelectScrollSearch } from '@/hooks/useSelectScrollSearch';
import { useSelectPropsWithInitial } from '@/hooks/useSelectWithInitialValue';

const useCaseResolutionFilter = (formProps: FormProps, filters: any[]) => {
  const { form } = formProps;
  const companyId = Form.useWatch('empresa', formProps.form);
  const initialValues: Record<string, any> = useMemo(
    () =>
      Object.fromEntries(
        filters.map(filter => {
          const valueParsed = parseInt(filter.value, 10);
          const value = isNaN(valueParsed) ? filter.value : valueParsed;

          return [filter.field, value];
        }),
      ),

    [filters],
  );
  const { setInitialValuesSetted } = useFormInitialSet(form, initialValues, [
    {
      watchField: 'empresa',
      resetFields: ['movil'],
    },
  ]);

  useEffect(() => {
    setInitialValuesSetted(false);
  }, [initialValues, setInitialValuesSetted]);
  const { selectProps: companySelectProps } = useSelectScrollSearch(
    {
      resource: 'empresas',
      optionLabel: (item: any) => item.full_name,
    },
    { saveItem: true },
  );
  const { selectProps: machineSelectProps } = useSelectScrollSearch({
    resource: 'moviles',
    optionLabel: (item: any) => item.description,
    optionValue: (item: any) => item.id,
    filters: [
      {
        value: companyId,
        operator: 'eq' as const,
        field: 'empresa',
      },
    ],

    meta: {
      paginate: 1,
      full: 0,
      showNoUnit: true,
      showDisabled: true,
    },
  });
  const companySelectPropsWithInitials = useSelectPropsWithInitial({
    selectProps: companySelectProps, // viene del contexto/superior
    resource: 'empresas',
    initialValue: initialValues.empresa,
    labelKey: 'full_name',
    valueKey: 'id',
  });
  const machineSelectPropsWithInitials = useSelectPropsWithInitial({
    selectProps: machineSelectProps,
    resource: 'moviles',
    initialValue: initialValues.movil,
    labelKey: 'description',
    valueKey: 'id',
  });

  return {
    companySelectProps: companySelectPropsWithInitials,
    machineSelectProps: machineSelectPropsWithInitials,
  };
};

export default useCaseResolutionFilter;
